"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_8b9a4cad{position:relative;font-size:12px;background:" }, { "theme": "listBackground", "defaultValue": "#ffffff" }, { "rawString": ";color:" }, { "theme": "listText", "defaultValue": "#333333" }, { "rawString": "}.focusZone_8b9a4cad{display:inline-block;min-width:100%;min-height:1px}.rootIsHorizontalConstrained_8b9a4cad{overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch}.root_8b9a4cad .ms-List-cell{min-height:38px;word-break:break-word}.rootCompact_8b9a4cad .ms-List-cell{min-height:32px}\n" }]);
exports.root = "root_8b9a4cad";
exports.focusZone = "focusZone_8b9a4cad";
exports.rootIsHorizontalConstrained = "rootIsHorizontalConstrained_8b9a4cad";
exports.rootCompact = "rootCompact_8b9a4cad";
//# sourceMappingURL=DetailsList.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/DetailsList/DetailsList.scss.js
// module id = 922
// module chunks = 0